import { featuredArticles, hotRoutes } from './homeData';

export interface ArticleDetail {
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  author: string;
  readTime: string;
  tags: string[];
  imageSeq: string;
  summary: string;
  content: string;
  relatedArticles: string[];
}

export const articleDetails: Record<string, ArticleDetail> = {
  'sunset-romance-3day': {
    slug: 'sunset-romance-3day',
    title: '日落浪漫·三日精华游',
    category: '蜜月行程',
    categorySlug: 'honeymoon',
    date: '2026-07-20',
    author: '小爱',
    readTime: '6分钟',
    tags: ['日落巡航', '海滨晚餐', '私密别墅', '蜜月推荐'],
    imageSeq: 'hot-route-1',
    summary: '从接机到送机，三天两晚的精华行程，涵盖爱情岛最浪漫的日落观赏点、私密海滨晚餐和特色住宿体验。',
    relatedArticles: ['best-season-guide', 'honeymoon-budget-plan'],
    content: `<h2>行程概览</h2>
<p>爱情岛三日精华游专为时间有限但追求极致浪漫体验的情侣和新婚夫妇设计。三天的行程紧凑而不匆忙，每一刻都精心安排，让你们在短时间内感受到爱情岛最动人的魅力。</p>

<h2>第一天：抵达与初见</h2>
<p>抵达爱情岛后，我们的专车会在码头/机场等候，直接送您前往精选的海景度假别墅。入住后，可以先在私人泳池边享受欢迎饮品，感受海风轻拂的惬意。</p>
<p>傍晚时分，我们会为您安排一场私密的日落巡航。乘坐双体帆船出海，在金色晚霞中举杯共饮香槟，欣赏太阳缓缓沉入海平线的壮丽景象。船上有专业摄影师为您捕捉每一个甜蜜瞬间。</p>
<p>晚餐安排在沙滩上，烛光、鲜花、海浪声交织成一曲浪漫乐章。主厨精心准备的五道式海鲜晚宴，搭配精选葡萄酒，为第一天画上完美句号。</p>

<h2>第二天：深度探索</h2>
<p>清晨在轻柔的海浪声中自然醒来，享用别墅管家送来的漂浮早餐——在泳池中享用新鲜水果、牛角面包和现煮咖啡，这绝对是Instagram上最令人羡慕的早餐场景。</p>
<p>上午前往爱情岛最著名的"心形礁"，乘坐玻璃底船观赏五彩斑斓的珊瑚和热带鱼群。如果会游泳，还可以穿上潜水装备与鱼群共舞，在海底世界留下独特的二人回忆。</p>
<p>下午安排双人SPA体验，在临海的SPA小屋中，听着海浪声享受精油按摩和花瓣浴，让身心彻底放松。</p>
<p>晚餐在悬崖餐厅享用，这里被誉为爱情岛最佳日落观赏点。整个餐厅悬于海崖之上，360度无死角海景，是求婚和庆祝纪念日的绝佳场所。</p>

<h2>第三天：告别与珍藏</h2>
<p>最后一天，您可以睡到自然醒，或早起去看一场海上日出。早餐后，我们会带您去爱情岛最私密的白沙滩漫步，这里游客稀少，仿佛你们的私人海滩。</p>
<p>中午在当地最有特色的海鲜市场品尝最新鲜的海产，感受当地人的生活气息。之后根据您的航班/船班时间，专车送您前往码头/机场。</p>
<p>离开前，您将收到一份精心制作的旅行纪念册，记录下这三天旅程中的每一个美好瞬间。</p>

<h2>费用包含</h2>
<ul>
<li>两晚海景度假别墅住宿（含每日漂浮早餐）</li>
<li>往返码头/机场专车接送</li>
<li>日落双体帆船巡航（含香槟和小食）</li>
<li>沙滩烛光晚餐一次</li>
<li>悬崖餐厅晚餐一次</li>
<li>心形礁玻璃底船游览</li>
<li>双人SPA体验（90分钟）</li>
<li>全程专业摄影师跟拍</li>
<li>精美旅行纪念册一本</li>
</ul>

<h2>温馨提示</h2>
<p>建议提前2周以上预订以确保心仪房型可用。晕船的旅客请提前准备晕船药。行程可根据天气情况灵活调整先后顺序。</p>`,
  },
  'island-romance-5day': {
    slug: 'island-romance-5day',
    title: '海岛浪漫·五日深度体验',
    category: '情侣度假',
    categorySlug: 'couple',
    date: '2026-07-18',
    author: '浪漫旅行家',
    readTime: '8分钟',
    tags: ['浮潜体验', '沙滩漫步', '海岛SPA', '情侣专享'],
    imageSeq: 'hot-route-2',
    summary: '五天深度探索，包含浮潜、沙滩烛光晚餐、双人SPA等丰富体验，让你们尽情享受二人世界。',
    relatedArticles: ['top10-sunset-spots', 'island-food-map'],
    content: `<h2>行程概览</h2>
<p>五天四晚的深度体验行程，让你们有充足的时间感受爱情岛的每一个浪漫角落。相比三日精华游，多出的两天让你们能够更加从容地探索、放松和享受二人世界。</p>

<h2>第一天：浪漫抵达</h2>
<p>抵达后入住精选海景度假酒店，稍作休息后前往酒店私人沙滩。傍晚时分，我们为您准备了沙滩欢迎鸡尾酒会，在夕阳下与爱人共饮，开启美好的假期。晚餐在酒店的海景餐厅享用，主打当地海鲜和创意融合料理。</p>

<h2>第二天：海洋奇遇</h2>
<p>全天海洋探险日！上午前往爱情岛最著名的浮潜点"蓝色秘境"，水质清澈见底，珊瑚覆盖率高达80%。即使不会游泳，也可以穿上救生衣在浅水区观赏热带鱼群。</p>
<p>中午在无人岛上享用野餐午餐，整个岛屿仿佛只属于你们两人。下午继续探索另一处浮潜点，运气好的话可以看到海龟。</p>
<p>晚上回到酒店后，享受一次舒缓的芳香按摩，缓解一天的运动疲劳。</p>

<h2>第三天：浪漫仪式</h2>
<p>上午自由活动，可以在无边泳池边晒太阳、看书，或者去酒店的瑜伽课程体验一次双人瑜伽。</p>
<p>下午的重头戏是"沙滩誓言仪式"——这不是婚礼，而是一个浪漫的仪式体验。在夕阳下的沙滩上，在牧师的见证下（可选），交换你们的爱情誓言，为感情增添一份庄重的仪式感。专业摄影师全程记录。</p>
<p>仪式结束后是沙滩烛光晚餐，精心布置的餐桌、定制菜单和专属服务，让这个夜晚格外难忘。</p>

<h2>第四天：秘境探索</h2>
<p>今天离开主岛，乘坐快艇前往周边秘境岛屿。第一站是"椰林岛"，岛上遍布百年椰子树，可以品尝最新鲜的椰青。第二站是"贝壳沙滩"，这里的沙滩由无数细小的贝壳组成，在阳光下闪闪发光。</p>
<p>中午在海边渔村品尝当地渔家菜，体验最地道的海岛美食。下午可以在渔村附近的天然泳池游泳，这里的水比酒店泳池更加清澈。</p>
<p>傍晚返回主岛，在酒店的意大利餐厅享用晚餐，品尝手工意面和窑烤披萨。</p>

<h2>第五天：温柔告别</h2>
<p>睡到自然醒，享用最后一顿漂浮早餐。上午在酒店附近闲逛，购买一些当地手工艺品作为纪念。根据航班时间，专车送您前往机场。</p>

<h2>费用包含</h2>
<ul>
<li>四晚海景度假酒店住宿（含每日早餐）</li>
<li>往返接送服务</li>
<li>全天海洋探险（含浮潜装备、快艇、午餐）</li>
<li>沙滩誓言仪式体验（含布置、牧师、摄影）</li>
<li>双人SPA一次</li>
<li>沙滩烛光晚餐一次</li>
<li>秘境岛屿一日游</li>
</ul>`,
  },
  'lifetime-proposal-4day': {
    slug: 'lifetime-proposal-4day',
    title: '一生一世·求婚定制之旅',
    category: '求婚之旅',
    categorySlug: 'proposal',
    date: '2026-07-15',
    author: '求婚策划师',
    readTime: '7分钟',
    tags: ['惊喜求婚', '专业摄影', '定制仪式', '求婚策划'],
    imageSeq: 'hot-route-3',
    summary: '专业团队全程策划，从场地布置到摄影记录，为你打造一场令TA感动落泪的完美求婚。',
    relatedArticles: ['proposal-plan-complete', 'top10-sunset-spots'],
    content: `<h2>行程概览</h2>
<p>这是一趟以求婚为核心目标而精心设计的四天三晚旅程。我们的专业策划团队会与您保持密切沟通，确保每一个细节都符合您的期望，同时全程对您的伴侣保密，直到惊喜揭晓的那一刻。</p>

<h2>第一天：甜蜜铺垫</h2>
<p>抵达后入住我们为您精选的悬崖海景套房，房间内已提前布置好玫瑰花和欢迎卡片。下午自由活动，可以去沙滩散步、泳池戏水，让TA完全放松，不产生任何怀疑。</p>
<p>晚餐安排在海边餐厅，享用精致的海鲜大餐。我们的工作人员会在这期间与您确认第二天的所有细节安排。</p>

<h2>第二天：惊喜揭晓（求婚日）</h2>
<p>这是整个旅程的核心——求婚日！</p>
<p>上午安排双人SPA体验，让TA在精油和音乐中彻底放松。午餐后，我们以"参加沙滩派对"为由带你们前往求婚场地。</p>
<p>求婚场景我们提供以下方案供您选择：</p>
<p><strong>方案A - 沙滩日落求婚（最经典）：</strong>在私密沙滩上用玫瑰花瓣铺出一条花路，终点是由鲜花和纱幔装饰的求婚拱门。日落时分，海天一色的金光中，您单膝跪地，一切完美得像电影场景。</p>
<p><strong>方案B - 海底求婚（最惊喜）：</strong>在潜水过程中，我们的潜水员会突然拿出一块写着"嫁给我好吗？"的防水牌，在五彩斑斓的海底世界完成这场独一无二的求婚。</p>
<p><strong>方案C - 私人游艇求婚（最奢华）：</strong>在私人游艇上，海风轻拂，香槟微醺，在爱琴海般的蓝色海面上，为TA戴上戒指。</p>
<p>无论选择哪个方案，我们的摄影师和摄像师都会在不打扰的氛围中记录下每一个感动瞬间。求婚后还有庆祝晚宴和烟火表演。</p>

<h2>第三天：甜蜜庆祝</h2>
<p>求婚成功后的庆祝日！上午睡到自然醒，在房间享用香槟早午餐。下午安排情侣写真拍摄，在爱情岛最美的几个景点留下你们的甜蜜合影。</p>
<p>傍晚乘坐日落巡航，在海上欣赏夕阳，举杯庆祝人生新篇章的开始。晚餐在海岛最顶级的餐厅享用私宴，由主厨亲自为你们定制菜单。</p>

<h2>第四天：满载而归</h2>
<p>早餐后，您将收到一份精美的求婚全记录（照片精修30张+5分钟微电影），以及我们赠送的纪念礼物。根据航班时间送往机场。</p>

<h2>特别说明</h2>
<p>求婚方案需在出行前与策划师充分沟通确认。建议至少提前3周预订以确保场地和人员安排。如果您有自己的特殊想法，我们非常乐意配合执行。</p>`,
  },
  'free-spirit-7day': {
    slug: 'free-spirit-7day',
    title: '随心所欲·七日自由行攻略',
    category: '自由行',
    categorySlug: 'free-travel',
    date: '2026-07-12',
    author: '旅行达人',
    readTime: '10分钟',
    tags: ['灵活行程', '自驾推荐', '秘境探索', '自由规划'],
    imageSeq: 'hot-route-4',
    summary: '提供最全的自由行攻略，包含住宿推荐、交通指南、美食地图和景点分布，让你轻松规划专属旅程。',
    relatedArticles: ['island-food-map', 'travel-photo-tips'],
    content: `<h2>为什么选择自由行？</h2>
<p>自由行的魅力在于——你的旅程，你做主。不用赶时间、不用跟团走马观花，想在哪多停留就在哪多停留。对于喜欢自主探索的情侣来说，自由行是最能展现二人默契和创造独家回忆的方式。</p>

<h2>行前准备清单</h2>
<ul>
<li>预订往返交通（机票/船票），建议提前1-2个月以获得最优价格</li>
<li>预订住宿（旺季建议提前1个月以上）</li>
<li>下载离线地图（岛上部分区域信号较弱）</li>
<li>准备防晒用品（防晒霜SPF50+、墨镜、遮阳帽）</li>
<li>带上防水手机袋和防水相机</li>
<li>准备少量现金（部分小摊位不支持移动支付）</li>
</ul>

<h2>推荐住宿区域</h2>
<p><strong>主岛西海岸：</strong>日落海景区，酒店集中，餐饮选择多，适合第一次来岛的游客。推荐：望海度假酒店、日落海湾别墅。</p>
<p><strong>主岛东海岸：</strong>日出观赏区，相对安静，适合喜欢清静的情侣。推荐：晨光海景民宿、椰林精品酒店。</p>
<p><strong>离岛：</strong>极度私密，适合追求远离喧嚣的情侣。推荐：秘境岛度假村（仅6间客房，需提前2个月预订）。</p>

<h2>七日行程建议</h2>
<p><strong>Day 1：</strong>抵达后入住酒店→沙滩散步适应环境→海边日落→夜市晚餐（推荐：海鲜烧烤+椰子冰沙）</p>
<p><strong>Day 2：</strong>租一辆电动车环岛游→心形礁→灯塔公园→悬崖咖啡厅下午茶→西海岸日落</p>
<p><strong>Day 3：</strong>出海一日游（浮潜+无人岛午餐）→傍晚返回→沙滩按摩→网红餐厅晚餐</p>
<p><strong>Day 4：</strong>睡到自然醒→当地市场逛早市→秘境白沙滩→半山腰餐厅午餐→下午自由活动→海滩篝火晚会</p>
<p><strong>Day 5：</strong>跳岛游（快艇前往2-3个周边小岛）→椰林岛→贝壳沙滩→渔村晚餐</p>
<p><strong>Day 6：</strong>双人SPA体验→购物买伴手礼→海岛最高点看全景→告别晚餐（推荐：悬崖餐厅）</p>
<p><strong>Day 7：</strong>最后的海滩时光→酒店退房→前往机场</p>

<h2>交通指南</h2>
<p>岛上主要交通工具是电动车和观光车，可在酒店或镇上租车点租赁。电动车日租金约80-150元，需押金。建议租车时拍照留证，检查电量是否充足。</p>
<p>去离岛需乘坐快艇或轮渡，可在码头现场买票或通过酒店前台预订。部分偏远离岛需包船前往，建议提前一天预约。</p>

<h2>美食地图</h2>
<p>参见我们的<a href="/article/island-food-map">《爱情岛美食地图》</a>专题文章，详细介绍了岛上最值得去的12家餐厅。</p>

<h2>预算参考（双人）</h2>
<ul>
<li>交通（往返+岛上）：2000-4000元</li>
<li>住宿（6晚）：2400-12000元（丰俭由人）</li>
<li>餐饮：1500-3000元</li>
<li>活动与门票：1000-3000元</li>
<li>总计：约6900-22000元</li>
</ul>`,
  },
  'best-season-guide': {
    slug: 'best-season-guide',
    title: '爱情岛最佳旅游季节全攻略：什么时候去最浪漫？',
    category: '蜜月行程',
    categorySlug: 'honeymoon',
    date: '2026-07-15',
    author: '小爱',
    readTime: '8分钟',
    tags: ['旅游季节', '气候攻略', '出行建议'],
    imageSeq: 'article-season',
    summary: '爱情岛地处热带，全年温暖如春，但不同季节有着截然不同的风情。',
    relatedArticles: ['honeymoon-budget-plan', 'sunset-romance-3day'],
    content: `<h2>爱情岛气候概览</h2>
<p>爱情岛地处热带，属热带海洋性气候，全年温暖湿润，年平均气温在25-30°C之间。海水温度常年维持在26-29°C，一年四季都适合游泳和水上活动。</p>

<h2>最佳旅游季节：11月至次年4月（旱季）</h2>
<p>这是爱情岛最舒适的季节，也是传统意义上的旅游旺季。此时降雨量少，阳光充足，天空湛蓝，海水清澈见底。白天温度在28-30°C左右，夜晚凉爽宜人，非常适合各种户外活动和海滩度假。</p>
<p>特别推荐12月至2月出行，此时气候最为舒适，而且可以避开国内寒潮，享受温暖浪漫的冬日阳光。不过这段时间也是价格最高、游客最多的时期，建议至少提前1个月预订。</p>

<h2>性价比之选：5月至10月（雨季）</h2>
<p>雨季的爱情岛同样迷人。虽然降雨量增加，但雨水通常集中在下午或傍晚，持续时间短，上午依然可以享受充足的阳光。这段时间游客较少、酒店和机票价格大幅下降（部分酒店降价30%-50%），是不错的性价比之选。</p>
<p>雨季的另一个惊喜是：雨后空气格外清新，植被郁郁葱葱，天空常常出现绚丽的彩虹。而且海洋生物更加活跃，浮潜体验更好。</p>
<p>出行建议：带好雨具，将重要户外活动安排在上午，下午可安排SPA、参观等室内项目。</p>

<h2>各月份特点速览</h2>
<ul>
<li><strong>1月-2月：</strong>最佳季节！天气完美，但价格最高，需提前预订。适合蜜月旅行。</li>
<li><strong>3月-4月：</strong>依然是好季节，游客略少，价格稍降。适合情侣度假。</li>
<li><strong>5月-6月：</strong>雨季开始，雨水增多但多为阵雨。价格开始下降，适合预算有限的旅行者。</li>
<li><strong>7月-8月：</strong>暑假旺季，国内游客增多。天气炎热潮湿，但海岛活动丰富。适合家庭和学生旅行。</li>
<li><strong>9月-10月：</strong>台风季节，出行前需关注天气预报。价格最低，适合说走就走的随性旅行。</li>
<li><strong>11月-12月：</strong>旱季回归，天气转好。11月性价比最高（好天气+旺季前价格），12月圣诞新年期间价格上涨。</li>
</ul>

<h2>特别节日提醒</h2>
<p>情人节（2月14日）和七夕节期间，爱情岛会举办特别的浪漫活动，但人流量极大、价格上涨明显。如果想要特别的节日体验，建议提前3个月预订。如果想要宁静的二人世界，建议避开这些日期，选择节日前后的时间出行。</p>`,
  },
  'top10-sunset-spots': {
    slug: 'top10-sunset-spots',
    title: '爱情岛十大最美日落观赏地：每一帧都是壁纸',
    category: '情侣度假',
    categorySlug: 'couple',
    date: '2026-07-10',
    author: '浪漫摄影师',
    readTime: '12分钟',
    tags: ['日落观赏', '拍照攻略', '景点推荐'],
    imageSeq: 'article-sunset',
    summary: '我们走遍了爱情岛的每一个角落，为你精选出十个最适合二人共赏日落的绝美地点。',
    relatedArticles: ['island-romance-5day', 'travel-photo-tips'],
    content: `<h2>为什么爱情岛的日落如此特别？</h2>
<p>爱情岛位于热带海域，空气纯净、水汽适中，日落的色彩层次极为丰富。加上独特的海岛地貌——悬崖、沙滩、礁石、椰林——形成了多样的观赏视角。无论是想要大气磅礴的海上落日，还是温柔浪漫的沙滩夕阳，爱情岛都能满足你。</p>

<h2>十大最美日落观赏地</h2>

<h3>1. 天涯悬崖（NO.1推荐）</h3>
<p>位于主岛最西端的悬崖观景台，海拔约80米。站在这里，整个爱情岛的西海岸尽收眼底。日落时分，天空从金黄渐变到橙红再到深紫，海面像一面巨大的镜子倒映着整个天空。这是岛上最受欢迎的日落观赏点，建议下午5点前到达占位。</p>
<p><strong>拍照tips：</strong>使用长焦镜头拍摄太阳与礁石的剪影，或者用广角拍摄全景，把人也拍进去制造"世界尽头"的感觉。</p>

<h3>2. 星月沙滩</h3>
<p>一片月牙形的白沙滩，沙质细腻如粉。日落时夕阳刚好从沙滩正对面落入海中，光线柔和温暖，是拍摄情侣剪影的最佳地点。沙滩坡度平缓，退潮时会形成镜面效果。</p>
<p><strong>拍照tips：</strong>退潮时拍摄反射倒影，可以让你们看起来像站在天空中一样。</p>

<h3>3. 灯塔之巅</h3>
<p>岛上的百年灯塔，经过修复后开放参观。爬上灯塔顶端，360度无死角海景令人惊叹。日暮时分，灯塔亮起温暖的灯光，与夕阳余晖交相辉映。</p>
<p><strong>拍照tips：</strong>以灯塔为前景拍摄日落，或者从灯塔内部向外拍摄，营造画框构图效果。</p>

<h3>4. 椰林长廊</h3>
<p>一条长约2公里的椰林大道，走在这里仿佛置身热带电影场景。夕阳透过椰叶缝隙洒下斑驳光影，非常适合漫步和拍照。</p>
<p><strong>拍照tips：</strong>逆光拍摄椰叶剪影，或者沿着林荫道纵向构图，营造纵深感。</p>

<h3>5. 礁石公园</h3>
<p>退潮后露出大片黑色火山礁石，与金色夕阳形成强烈的视觉对比。潮池中还会倒映天空色彩，别有一番风味。</p>
<p><strong>拍照tips：</strong>利用潮池拍摄倒影，大光比场景适合拍摄HDR或使用渐变滤镜。</p>

<h3>6. 渔人码头</h3>
<p>傍晚时分渔船归港，桅杆在夕阳中摇曳，充满生活气息和画面感。这里的日落更有烟火气息，附近还有海鲜排档可以边吃边赏日落。</p>

<h3>7. 悬崖餐厅</h3>
<p>岛上最浪漫的用餐地点，建在20米高的海崖上。预定傍晚的座位，一边享受美食一边欣赏日落，是很多情侣的求婚首选地。需要提前一周以上预订。</p>

<h3>8. 情人桥</h3>
<p>一座连接主岛和小离岛的木质栈桥，长约200米。站在桥中央，前后左右都是海水，夕阳时分仿佛走在通往太阳的金色大道上。</p>

<h3>9. 山顶教堂</h3>
<p>位于岛中央山顶的小教堂，白色建筑在绿色丛林中格外醒目。教堂前的草坪是俯瞰全岛和欣赏日落的绝佳位置。这里也是举办海岛婚礼的热门地点。</p>

<h3>10. 秘境沙滩</h3>
<p>需要徒步约20分钟才能到达的隐秘沙滩，游客很少。如果你想要一个二人专属的日落时刻，这里是最好的选择。记得带好手电筒，天黑后的山路需要照明。</p>`,
  },
};

export const categoryArticles: Record<string, ArticleDetail[]> = {
  honeymoon: [
    articleDetails['sunset-romance-3day'],
    articleDetails['best-season-guide'],
  ],
  couple: [
    articleDetails['island-romance-5day'],
    articleDetails['top10-sunset-spots'],
  ],
  proposal: [
    articleDetails['lifetime-proposal-4day'],
  ],
  'free-travel': [
    articleDetails['free-spirit-7day'],
  ],
};